import { useContext } from "react";
import AuthContext, { AuthState } from "../contexts/AuthContext";
import { Outlet } from "react-router";
import useDeviceSize, { DeviceSize } from "../hooks/useDeviceSize";
import BigLoader from "../common/BigLoader";
import MobileHeader from "./MobileHeader";
import SideHeader from "./SideHeader";
import { Link } from "react-router-dom";

type Props = {
    children?: React.ReactNode;
}

const HeaderLayout = ({ children }: Props) => {
    const { authState } = useContext(AuthContext);
    const device = useDeviceSize();


    if (authState !== AuthState.LOGGED_IN) {
        return <BigLoader />
    }

    if (device === DeviceSize.Mobile) {
        return (
            <div >
                <MobileHeader />
                <div className="h-[calc(100vh-56px)] overflow-auto bg-white">
                    <Outlet />
                </div>
            </div>
        )
    }

    return (
        <div className="flex">
            <SideHeader />
            {/* Content */}
            <div className="flex-1 h-screen overflow-auto bg-white" id="main-content">
                <Outlet />
            </div>
        </div>
    )
}

export default HeaderLayout